import { useAdminLang } from "./i18n";

// Converted 1:1 from the Xintra template (index.html, header-responsive-search modal).
export default function AdminSearchModal() {
  const { t } = useAdminLang();

  return (
    <div className="modal fade" id="header-responsive-search" tabIndex={-1} aria-labelledby="header-responsive-search" aria-hidden="true">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-body">
            <div className="input-group">
              <input type="text" className="form-control border-end-0" placeholder={t("جستجو")} aria-label={t("جستجو")} aria-describedby="button-addon2" />
              {" "}
              <button className="btn btn-primary" type="button" id="button-addon2">
                <i className="bi bi-search"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
